function n(t, r = "N/A") {
  try {
    if (Array.isArray(t))
      return t.filter(Boolean).join(" ") || r;
    const e = t;
    return e && [e.firstName, e.lastName].filter(Boolean).join(" ") || r;
  } catch {
    return r;
  }
}
export {
  n as default
};
